import React from 'react';
import { DataTable } from 'primereact/datatable';
import { useNavigate } from 'react-router';
import { Column } from 'primereact/column';
import { CAMENU } from '../../../constants';
import { CaMenuTabindex } from '../../../utils/typeConstants';
import './correctiveActionsGrid.scss';

interface CorrectiveActionsGridProps {
    actions: any;
}

const CorrectiveActionsGrid: React.FC<CorrectiveActionsGridProps> = ({ 
    actions, 
}) => {   

    const navigate = useNavigate();

    const actionBodyTemplate = (/*rowData: any*/) => {
        return (
            <button style={{backgroundColor:'#E23636',color:'white',borderRadius:'15px',padding:'2px 10px 2px 10px',borderColor:'#E23636'}}
                onClick={() => navigate(CAMENU + '/' + CaMenuTabindex.NeedsAction, { replace: true })}
                className="inline-flex items-center"
            >
                Needs Action 
                <i className='pi pi-external-link ps-1'/>
            </button>
        );
    };

    return (
        <div className="corrective-actions-table-wrapper">
            <DataTable className='CorrectiveActionsGrid'
                value={actions}
                scrollable scrollHeight="calc(85vh - 400px)"
                dataKey="corrective_action_id"
                emptyMessage="No Records" sortMode="multiple"
            >
                <Column
                    header="Employee"
                    field="employee_name"
                    sortable
                    sortField="employee_name"
                />
                <Column
                    header="Status"
                    field="ca_status_name"
                    sortable
                    sortField="ca_status_name"
                />
                <Column 
                    body={actionBodyTemplate} 
                    alignFrozen="right"
                    style={{ width: '12rem',padding:'1px' }}
                />
            </DataTable>
        </div>
    );
};

export default CorrectiveActionsGrid;